export default __webpack_public_path__ + "next-red-aXr.svg";